import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Checkbox,
  Upload as UploadAntd,
  Image
} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { ExclamationCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const s3Config = {
  region: 'us-east-1',
  credentials: {
    accessKeyId: "IJTXH751MBXUWMTWM0SF",
    secretAccessKey: "lfTPRJ2PqAxsp3poTW9YlHktgaL1cFkLup8LidW9",
  },
  endpoint: "https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/",
  forcePathStyle: true,
};

const { TextArea } = Input;
const Search = Input.Search;
const { Option } = Select;
const s3Client = new S3Client(s3Config);
function Product() {
  const { request } = useRequest();
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selected, setSelected] = useState();

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (_, { image }) => {
        return (
          <div>
            <Image src={image[0]} />
          </div>
        );
      },
    },
    {
      title: "Product Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Category Name",
      dataIndex: "category",
      key: "category",
      render: (_, { categoryData }) => {
        return (
          <div>
            {categoryData ? categoryData.name : "--"}
          </div>

        );
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Total Discount Price",
      dataIndex: "discountPrice",
      key: "discountPrice",
    },

    {
      title: "Action",
      render: (_, record) => {
        return (
          <Button
            className="tb-view"
            onClick={() => { setVisible(true); setSelected(record) }}
          >
            <i className="fa fa-light fa-pencil"></i> Edit
          </Button>
        );
      },
    },
  ];

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  const fetchData = (pagination, filters) => {
    request({
      url: `/admin/product/list?page=${pagination.current}&limit=${pagination.pageSize}&search=${debouncedSearchText}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.docs);
        setPagination({ current: pagination.current, total: data.data.totalDocs });
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  return (
    <Main>
      <div className="tabled">
        <Row>
          <Col xs="24" md={24} lg={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Product Management"
              extra={
                <>
                  <Search
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                  />
                  <Button onClick={() => setVisible(true)}>Add Product</Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={pagination}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddFrom
          show={visible}
          hide={() => { setSelected(); setVisible(false); }}
          data={selected}
          refresh={() => setRefresh(prev => !prev)}
        />
      )}
    </Main>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [file, setFile] = useState([]);
  const [content, setContent] = useState('');
  const uploadFileToS3 = async (file, bucketName) => {
    const key = "pharmacy/product" + file.name
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      console.log(data)
      return data;
    } catch (err) {
      throw err;
    }
  };
  const handleChange = async ({ fileList }) => {
    const promises = fileList.map(async (fileItem) => {
      try {
        const data = await uploadFileToS3(fileItem.originFileObj, 'invent-colab-obj-bucket');
        return {
          uid: fileItem.uid,
          name: fileItem.name,
          status: 'done',
          url: data.Location,
          thumbUrl: data.Location,
        };
      } catch (err) {
        console.error(err);
        return null;
      }
    });

    const uploadedFiles = await Promise.all(promises);
    const validFiles = uploadedFiles.filter(Boolean); // Exclude null results if any upload failed
    setFile(validFiles);
  };
  // const handleChange = async (event) => {
  //   const { file } = event;
  //   setFile([file]);
  //   try {
  //     const data = await uploadFileToS3(file, 'invent-colab-obj-bucket');
  //     const fileData = {
  //       uid: file.uid,
  //       name: file.name,
  //       status: 'done',
  //       url: data.Location,
  //       thumbUrl: data.Location,
  //     };
  //     setFile([fileData]);
  //     console.log(data);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  useEffect(() => {
    if (data) form.setFieldsValue({ ...data });
  }, [data]);



  const onCreate = (values) => {
    setLoading(true);
    let payload = {}
    payload.name = values.name
    payload.description = content
    payload.price = values.price
    payload.discountPrice = values.discountPrice
    payload.category = values.category
    payload.image = file.length > 0 && file.map(f => f.url)
    request({
      url: data ? `/admin/product/edit-product/${data._id}` : `/admin/product/add-product`,
      method: data ? 'PUT' : 'POST',
      data: payload,
      onSuccess: () => {
        setLoading(false);
        refresh();
        hide();
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };


  const handleContentChange = (newContent) => {
    setContent(newContent);
  };

  useEffect(() => {
    fetchCategories();
  }, [data]);

  const fetchCategories = () => {
    request({
      url: `/common/category-list`,
      method: 'GET',
      onSuccess: (data) => {
        console.log(data.data)
        setCategories(data.data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  return (
    <Modal
      visible={show}
      title={`${data ? 'Edit' : 'Create'} Product`}
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Col span={24}>
          <Form.Item
            label="Product Name"
            name="name"
            rules={[{ required: true, message: "Please enter the Product name!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="Price"
            name="price"
            rules={[{ required: true, message: "Please enter the Product price!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="Discount Price"
            name="discountPrice"
            rules={[{ required: true, message: "Please enter the Product Discount Price!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="Category"
            name="category"
            rules={[{ required: true, message: "Please select a category!" }]}
          >
            <Select
              placeholder="Select Category"
              name="category"
            >
              {categories.map((category) => (
                <Option key={category._id} value={category._id}>{category.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>



        <Col span={24}>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: "Please Enter the  description!" }
            ]}
          >
            <ReactQuill value={content} onChange={handleContentChange} />
            {/* <TextArea rows={4} /> */}

          </Form.Item>
        </Col>

        <Col span={24}>
          <UploadAntd
            listType="picture"
            maxCount={5}  // Allow up to 5 images, adjust as needed
            customRequest={({ file, onSuccess }) => onSuccess("ok")}  // Bypass Ant Design's upload since we handle it
            onChange={handleChange}
            onRemove={(file) => setFile(prev => prev.filter(f => f.uid !== file.uid))}
            fileList={file}
            multiple  // Enable multiple file uploads
          >
            {file.length < 5 && <Button icon={<UploadOutlined />}>Upload</Button>}  {/* Limit upload to maxCount */}
          </UploadAntd>
        </Col>


      </Form>

    </Modal>
  );
};

export default Product;
